// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fv-0";
export var fileCarousel = "_fv-2";
export var removeFileButton = "_fv-1";